import { Checkbox } from '@mantine/core';
import { PlanMarket } from '@zorro/clients';
import { Box, Flex, Grid, Text } from '@zorro/web/design-system';

import { getPlanMarketIconLabelConfig } from '../../PlanBadge';
import classNames from './PlanFilter.module.scss';

export const PLAN_MARKET_FILTER_VALUES = [
  PlanMarket.ON_EXCHANGE,
  PlanMarket.OFF_EXCHANGE,
  PlanMarket.BOTH_MARKETS,
];

type Props = {
  filterOptions: Set<PlanMarket> | undefined;
  selectedFilters: string[];
};

export const PlanMarketFilters = ({
  filterOptions,
  selectedFilters,
}: Props) => {
  if (!filterOptions) {
    return null;
  }
  return (
    <Grid columns={2} gap="sm">
      {PLAN_MARKET_FILTER_VALUES.map((filter) => {
        const { icon, label: planMarketLabel } =
          getPlanMarketIconLabelConfig(filter);

        if (filterOptions.has(filter)) {
          const checkboxValue = filter;
          return (
            <Grid.Col key={filter} span={1}>
              <Checkbox.Card
                checked={selectedFilters?.includes(checkboxValue)}
                value={checkboxValue}
                className={classNames.checkboxCard}
              >
                <Flex p="md" align="center" gap="xs" h="3rem">
                  <Box className={classNames.planMarket} data-variant={filter}>
                    {icon}
                  </Box>
                  <Text size="sm">{planMarketLabel}</Text>
                </Flex>
              </Checkbox.Card>
            </Grid.Col>
          );
        }
        return null;
      })}
    </Grid>
  );
};
